<template>
  <el-dialog
    top="50px"
    custom-class="dlg-area-code"
    v-model="dlgACodeVisible"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-input
      v-model="title"
      placeholder="输入关键字进行搜索"
      @input="loadFilter"
    />
    <el-tree
      ref="$area"
      node-key="id"
      :props="options"
      :data="tree"
      :auto-expand-parent="false"
      :expand-on-click-node="false"
      :filter-node-method="fnFilterNodes"
      highlight-current
      check-strictly
      show-checkbox
      accordion
      @node-click="handleNodeClick"
      @check-change="handleCheckChange"
    />
    <div class="dac-footer">
      <el-button type="default" @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: "AreaCode",
  props: {
    disabledRoot: false
  },
  computed: {
    ...mapState(['areas', 'isGettingAreasOrGotten'])
  },
  data() {
    return {
      dlgACodeVisible: false,
      options: {
        children: "children",
        label: "label"
      },
      title: "",
      value: "",
      tempValue: "",
      tree: [],
      close: null,
      itv: null
    };
  },
  mounted() {
    if(!this.isGettingAreasOrGotten) {
      this.setIsGettingAreasOrGotten(true)
      this.initAreas().then(() => {})      
    }
  },
  methods: {
    ...mapMutations(['setIsGettingAreasOrGotten']),
    init(options) {
      let { type, obj } = options;
      switch (type) {
        case "show":
          this.show(obj);
          break;
      }
    },
    initTree() {
      this.areas.forEach(obj => {
        obj.disabled = this.disabledRoot
      });
      this.tree = this.areas;
    },
    loadFilter(title) {
      this.setNodesNotShow(this.tree)
      clearTimeout(this.itv);
      this.itv = setTimeout(() => {
        this.$refs.$area.filter(title || this.title);
      }, 300);
    },
    clearChecked() {
      const { $area } = this.$refs;
      const keys = $area.getCheckedKeys();
      keys.forEach(key => {
        $area.setChecked(key, false);
      });
    },
    show(obj) {
      this.initTree()
      this.dlgACodeVisible = true;
      this.$nextTick(e => {
        this.clearChecked();
        this.value = obj.value;
        this.tempValue = obj.value;
        this.close = obj.close;
        if (this.value) {
          this.$refs.$area.setChecked(this.value, true);
        }
      });
    },
    confirm() {
      this.close && this.close(this.value);
      this.dlgACodeVisible = false;
    },
    cancel() {
      this.close && this.close(this.tempValue);
      this.dlgACodeVisible = false;
    },
    fnFilterNodes(value, data) {
      if(data.show) {
        return true
      }else if (value) {
        let show = data.label.indexOf(value) >= 0 || data.id.indexOf(value) >= 0
        if(show) this.setNodesShow(data.children)
        return show;
      }
      return true;
    },
    setNodesShow(children) {
      children.forEach(obj => {
        obj.show = true
        this.setNodesShow(obj.children || [])
      })
    },
    setNodesNotShow(children) {
      children.forEach(obj => {
        obj.show = false
        this.setNodesNotShow(obj.children || [])
      })
    },
    handleNodeClick(data) {
      const { $area } = this.$refs;
      if (data.disabled) return;
      $area.setChecked(data.id, this.value !== data.id);
    },
    handleCheckChange(data, checked) {
      const { $area } = this.$refs;
      if (data.disabled) {
        $area.setChecked(data.id, false);
        this.$message.info("行政区域代码不能选择省级");
      } else {
        if (checked) {
          if (this.value) $area.setChecked(this.value, false);
          $area.setChecked(data.id, true);
          this.$nextTick(e => {
            this.value = data.id;
          });
        } else {
          this.value = "";
        }
      }
    },
    ...mapActions(['initAreas'])
  }
};
</script>
<style lang="scss">
.dlg-area-code {
  min-width: 650px;
  max-width: 650px;
  .el-dialog__header,
  .el-dialog__footer {
    display: none;
  }
  .el-dialog__body {
    .el-tree {
      min-height: 500px;
      max-height: 600px;
      overflow: auto;
      
    }
    .dac-footer {
      margin-top: 10px;
      text-align: right;
    }
  }
}
</style>
